import { makeStyles } from "tss-react/mui";
export type IStyleParams = {
  locale: string;
};

const useStyles = makeStyles<{ params: IStyleParams }>({
  name: "ContactUs",
  uniqId: "contact_us",
})((theme, { params }, classes) => {
  return {
    aboutUsPage: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      height: "fit-content",
      padding: "100px 0",

      [theme.breakpoints.down("md")]: {
        paddingTop: 32,
      },
    },

    tabNamesContainer: {
      width: "100%",
      height: "fit-content",
      position: "relative",
      display: "flex",
      flexDirection: "row",
      margin: "0 -20px",
    },

    tabNameContainer: {
      width: "fit-content",
      height: "fit-content",
      position: "relative",
    },

    tabName: {
      color: "#c2c2c2",
      fontFamily:
        params.locale === "en-US"
          ? "Montserrat"
          : params.locale === "zh-CN"
          ? "Noto Sans SC"
          : "Noto Sans TC",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "120%",
      letterSpacing: "2.88px",
      padding: "0 20px",
      borderRight: "1px solid #333",
      cursor: "pointer",
    },

    activeTab: {
      color: "#333 !important",
    },

    lastTab: {
      borderStyle: "none !important",
    },

    underlineActiveTabContainer: {
      position: "absolute",
      width: "100%",
      height: "4px",
      bottom: -10,
      left: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
    },

    underlineActiveTab: {
      width: "50%",
      height: "100%",
      borderRadius: "2px",
      backgroundColor: "#333",
    },

    tabContentContainer: {
      position: "relative",
      margin: "10px 0 200px 0",
    },
  };
});

export default useStyles;
